import { defineComponent as ee, useAttrs as te, computed as a, ref as ae, toRef as le, openBlock as d, createElementBlock as g, mergeProps as V, withDirectives as oe, createElementVNode as L, toHandlers as ie, unref as m, normalizeClass as x, toDisplayString as B, createCommentVNode as b, createBlock as D, resolveDynamicComponent as ne, toRaw as se, renderSlot as ue, nextTick as re } from "vue";
import { RevButtonIcon as de } from "@ds/components/ButtonIcon";
import { useNativeInput as ce } from "../../../composables/useNativeInput.js";
import { vFocus as ve } from "../../../directives/focus.js";
import me from "../../../icons/generated/IconCrossInCircle.vue2.js";
import { useI18n as be } from "@ds/plugin";
import fe from "../../../translations/generic.translations.js";
import { isEmpty as S } from "../../../utils/isEmpty.js";
import { omit as he } from "../../../utils/omit.js";
import { tw as e } from "../../../utils/tailwind.js";
import { TYPES_WITH_DEFAULT_PLACEHOLDER as pe } from "../InputText.constant.js";
import { getCursorPosition as ye } from "../InputText.helpers.js";
const ge = ["disabled", "required", "value"], xe = ["for"], Ce = ["id", "role"], De = /* @__PURE__ */ ee({
  name: "RevInputTextFloatingLabel",
  inheritAttrs: !1,
  __name: "InputTextFloatingLabel",
  props: {
    autofocus: { type: Boolean },
    clearButtonAriaLabel: {},
    description: {},
    disabled: { type: Boolean },
    error: {},
    format: { type: Function },
    hasClearButton: { type: Boolean },
    helperTextClass: { type: [String, Boolean, Array, Object] },
    icon: {},
    iconProps: {},
    id: {},
    inputClass: { type: [String, Boolean, Array, Object] },
    label: {},
    modelValue: {},
    size: {},
    type: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue", "input", "invalid", "valid", "clear"],
  setup(t, { expose: F, emit: P }) {
    const i = P, f = te(), R = a(
      () => he(f, ["class", "style"])
    ), q = a(() => ({
      class: f.class,
      style: f.style
    })), n = ae(null);
    let T = String(t.format(t.modelValue));
    const h = ce(
      n,
      le(() => t.modelValue),
      {
        onInput: async (o) => {
          const r = n.value, w = o.target.value, N = r?.selectionStart ?? null, z = t.format(w), y = String(z);
          if (r && y !== w && (r.value = y, N !== null)) {
            await re();
            const E = ye(
              T,
              y,
              w,
              N
            );
            r.setSelectionRange(E, E);
          }
          T = y, i("update:modelValue", z), i("input", o);
        },
        onValidityChange: (o) => {
          o ? i("valid") : i(
            "invalid",
            n.value?.validity,
            n.value?.validationMessage ?? ""
          );
        }
      }
    ), O = () => {
      i("input", {
        target: {
          value: ""
        }
      }), i("update:modelValue", ""), i("clear"), n.value?.focus();
    }, l = a(() => t.size === "small"), c = a(() => !S(t.error)), p = a(
      () => typeof t.modelValue == "string" ? !S(t.modelValue) : !(typeof t.modelValue > "u")
    ), s = a(
      () => c.value || h.touched.value && h.invalid.value
    ), H = a(
      () => t.type ? pe.includes(t.type) : !1
    ), $ = a(() => !S(f.placeholder)), j = a(() => !(l.value && p.value)), C = a(
      () => !l.value && (h.focused.value || H.value || p.value || $.value)
    ), u = a(
      () => !l.value && t.hasClearButton && p.value && !t.disabled
    ), v = a(
      () => !l.value && !!t.icon && !u.value
    ), k = a(() => l.value ? "" : s.value && c.value ? t.error : t.description), I = a(() => {
      if (s.value)
        return s.value && `${t.id}_error`;
    }), M = a(
      () => ({
        ...R.value,
        id: t.id,
        type: t.type,
        "aria-label": t.label,
        ...s.value ? { "aria-invalid": "true" } : {},
        ...c.value ? { "aria-describedby": I.value } : {}
      })
    ), W = be(), U = t.clearButtonAriaLabel || W(fe.buttonClear), Y = a(() => t.id);
    F({
      input: n,
      inputContainerId: Y
    });
    const A = a(() => (o) => [
      e`motion-safe:transition-colors motion-safe:duration-200`,
      e`bg-static-default-low`,
      o && e`peer-hover:bg-static-default-low-hover peer-disabled:bg-transparent`,
      !o && e`hover:bg-static-default-low-hover disabled:bg-static-default-low-disabled`
    ]), G = a(() => [
      e`peer rounded-sm input-normalize relative w-full min-w-0 truncate pl-12`,
      e`focus-visible:outline-none`,
      t.inputClass,
      A.value(!1),
      l.value && s.value && p.value ? e`text-action-danger-hi disabled:text-action-default-hi-disabled` : e`text-action-default-hi disabled:text-action-default-hi-disabled`,
      l.value ? e`h-32` : e`input-normalize h-48`,
      C.value && e`pt-14`,
      u.value && e`pr-48 type-date:pr-8`,
      v.value && e`pr-44 type-date:pr-8`,
      !u.value && !v.value && e`pr-12`
    ]), J = a(() => [
      e`pointer-events-none absolute top-0 rounded-sm w-full border border-solid`,
      t.inputClass,
      l.value ? e`h-32` : e`h-48`,
      e`motion-safe:transition-colors motion-safe:duration-200`,
      e`peer-disabled:border-action-default-low-disabled peer-focus-visible:border-retina`,
      s.value ? e`border-action-danger-low peer-focus-visible:border-action-danger-low-pressed` : e`border-action-default-low peer-focus-visible:border-action-default-low-pressed`
    ]), K = a(() => [
      e`relative`,
      l.value ? e`body-1-bold` : e`body-1`
    ]), Q = a(() => [
      e`body-2 flex items-baseline peer-disabled:text-static-default-low-disabled`,
      e`mt-8`,
      t.helperTextClass,
      c.value ? e`text-static-danger-hi` : e`text-static-default-low`
    ]), X = a(() => [
      l.value && e`text-action-default-hi body-1-bold top-16`,
      l.value && c.value && e`text-static-danger-hi`,
      C.value && e`text-static-default-low caption top-5 transform-none`,
      !C.value && !l.value && e`text-action-default-hi body-1 top-24`,
      u.value && e`pr-36`,
      v.value && e`pr-32`,
      e`pointer-events-none absolute left-12 right-12 z-[inherit]`,
      e`max-w-full`,
      e`-translate-y-1/2 truncate peer-disabled:text-action-default-hi-disabled`,
      e`motion-safe:transition-all motion-safe:duration-200`
    ]), Z = a(() => [
      e`rounded-sm pointer-events-none absolute right-4 top-4 z-[1] size-40`,
      A.value(!0)
    ]), _ = a(() => [
      e`pointer-events-none absolute right-10 z-[1] h-40`,
      t.disabled ? e`text-static-default-low-disabled` : e`text-static-default-low`
    ]);
    return (o, r) => (d(), g("div", V(q.value, { class: K.value }), [
      oe(L("input", V({
        ref_key: "input",
        ref: n
      }, M.value, {
        class: G.value,
        "data-test": "input-text-input",
        disabled: t.disabled,
        required: t.required,
        value: t.format(t.modelValue)
      }, ie(m(h).listeners, !0)), null, 16, ge), [
        [m(ve), t.autofocus]
      ]),
      L("div", {
        "aria-hidden": "true",
        class: x(J.value)
      }, null, 2),
      j.value ? (d(), g("label", {
        key: 0,
        class: x(X.value),
        for: t.id
      }, B(t.label) + B(t.required ? " *" : ""), 11, xe)) : b("", !0),
      u.value || v.value ? (d(), g("div", {
        key: 1,
        class: x(Z.value)
      }, [
        u.value ? (d(), D(m(de), {
          key: 0,
          "aria-label": m(U),
          class: "pointer-events-auto absolute disabled:pointer-events-none",
          "data-test": "clear-button",
          disabled: t.disabled,
          icon: m(me),
          type: "button",
          variant: "ghost",
          onClick: O
        }, null, 8, ["aria-label", "disabled", "icon"])) : b("", !0),
        v.value ? (d(), D(ne(se(t.icon)), V({ key: 1 }, t.iconProps, {
          "aria-hidden": "true",
          class: _.value,
          "data-test": "icon",
          size: "20"
        }), null, 16, ["class"])) : b("", !0)
      ], 2)) : b("", !0),
      ue(o.$slots, "default"),
      k.value ? (d(), g("p", {
        key: 2,
        id: I.value,
        "aria-live": "assertive",
        class: x(Q.value),
        role: s.value ? "alert" : "presentation"
      }, B(k.value), 11, Ce)) : b("", !0)
    ], 16));
  }
});
export {
  De as default
};
